import { IsDefined, IsInt, IsObject, IsOptional, IsDate, IsDecimal } from 'class-validator';
import { BaseDto } from '../base.dto';
import type { PurchaseOrderDto } from '../purchaseOrder.dto';
import type { MerchantDto } from '../merchant.dto';
import type { SupplierDto } from '../supplier.dto';
import type { StockDto } from '../stock.dto';
import type { PurchaseOrderInvoiceDto } from './purchase-order-invoice.dto';
import type { UserDto } from '../user.dto';

export class PurchaseOrderStockPriceApprovalDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  supplierId: number;

  @IsDefined()
  @IsInt()
  stockId: number;

  @IsOptional()
  @IsInt()
  purchaseOrderId?: number;

  @IsOptional()
  @IsInt()
  purchaseOrderInvoiceId?: number;

  @IsOptional()
  @IsDecimal()
  oldCaseCost?: number;

  @IsOptional()
  @IsDecimal()
  newCaseCost?: number;

  @IsOptional()
  @IsInt()
  approvedById?: number;

  @IsOptional()
  @IsDate()
  approvedAt?: Date;

  /* Relationships */

  @IsOptional()
  @IsObject()
  merchant?: MerchantDto;

  @IsOptional()
  @IsObject()
  supplier?: SupplierDto;

  @IsOptional()
  @IsObject()
  stock?: StockDto;

  @IsOptional()
  @IsObject()
  purchaseOrder?: PurchaseOrderDto;

  @IsOptional()
  @IsObject()
  purchaseOrderInvoice?: PurchaseOrderInvoiceDto;

  @IsOptional()
  @IsObject()
  approvedBy?: UserDto;
}
